import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Button,
} from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";
import FilterListIcon from "@mui/icons-material/FilterList";
import { enqueueSnackbar } from "notistack";
import { usStates } from "../../utils/constant";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// Dummy options - replace with your real data
const STATUS_OPTIONS = [
  { value: "approved", name: "Approved" },
  { value: "pending", name: "Pending" },
  { value: "rejected", name: "Rejected" },
];

const STATES_OPTIONS = [
  "California",
  "Texas",
  "New York",
  "Florida",
  "Illinois",
];

const CATEGORIES_OPTIONS = [
  "Education",
  "Health",
  "Technology",
  "Finance",
  "Agriculture",
];

const ApplicationFilter = ({
  filterData,
  handleChange,
  handleChangeOther,
  handleClearFilter,
  searchFunction,
  applyFilters,
  clearFilters,
  setCaseType,
  caseType,
  setStates,
  states,
}) => {
  const [formattedUsers, setFormattedUsers] = useState([]);

  const get_user_list = async () => {
    // Add async logic if needed later
  };

  useEffect(() => {
    get_user_list();
  }, []);

  return (
    <div>
      {/* Status Dropdown */}
      {/* <FormControl fullWidth className="mb-3">
        <InputLabel>Status</InputLabel>
        <Select
          value={filterData.form_status}
          name="form_status"
          label="Status"
          onChange={handleChange}
        >
          {STATUS_OPTIONS.map((status) => (
            <MenuItem key={status.value} value={status.value}>
              {status.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}

      {/* States (Multi-select) */}
      <FormControl fullWidth required margin="normal">
        <InputLabel id="state-select-label">State</InputLabel>
        <Select
          labelId="state-select-label"
          name="state"
          value={states}
          onChange={(e) => setStates(e.target.value)}
          label="State"
        >
          {usStates.map((stateOption) => (
            <MenuItem key={stateOption} value={stateOption}>
              {stateOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl required fullWidth margin="normal">
        <InputLabel id="source-select-label">Category</InputLabel>
        <Select
          labelId="source-select-label"
          value={caseType}
          onChange={(e) => setCaseType(e.target.value)}
          label="Category"
        >
          <MenuItem value="unwanted_spam">Unwanted Spam Texts/Calls</MenuItem>
          <MenuItem value="scam_recovery">Scam Recovery</MenuItem>
          <MenuItem value="both">Both</MenuItem>
        </Select>
      </FormControl>

      {/* Action Buttons */}
      <div className="text-end mt-3">
        <Button
          variant="outlined"
          className="me-2"
          startIcon={<UndoIcon />}
          onClick={clearFilters}
        >
          Clear Filter
        </Button>
        <Button
          variant="contained"
          startIcon={<FilterListIcon />}
          onClick={applyFilters}
        >
          Filters
        </Button>
      </div>
    </div>
  );
};

export default ApplicationFilter;
